"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typedEdgeTypeMatrix = exports.edgeTypeMatrix = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
// this needs to conform to EdgeTypeMatrixType but is not typed as such to allow direct access to sub attributes
exports.edgeTypeMatrix = {
    // ...FW_EdgeTypeMatrix,
    Customer: {
        ...datamodel_core_1.edgeTypeMatrix.Customer,
        Irrigator: {
            customerHasIrrigator: {
                cardinality: undefined,
                edgeTypeId: 'customerHasIrrigator',
                labels: {
                    in: 'customer has irrigator',
                    out: 'irrigator belongs to customer',
                },
                edgeAttributes: {},
            },
        },
        IrrigationZone: {
            customerHasIrrigationZone: {
                cardinality: undefined,
                edgeTypeId: 'customerHasIrrigationZone',
                labels: {
                    in: 'customer has irrigation zone',
                    out: 'irrigation zone belongs to customer',
                },
                edgeAttributes: {},
            },
        },
        IrrigationPattern: {
            customerHasIrrigationPattern: {
                cardinality: undefined,
                edgeTypeId: 'customerHasIrrigationPattern',
                labels: {
                    in: 'customer has irrigation pattern',
                    out: 'irrigation pattern belongs to customer',
                },
                edgeAttributes: {},
            },
        },
        SpreadingEvent: {
            customerHasSpreadingEvent: {
                cardinality: undefined,
                edgeTypeId: 'customer_has_spreadingEvent',
                labels: {
                    in: 'Customer has spreading event',
                    out: 'Spreading event belongs to customer',
                },
                edgeAttributes: {},
            },
        },
        /** Removed as now provided from @iotv/datamodel-core */
        // Property: {
        //   customerHasProperty: {
        //     cardinality: undefined,
        //     edgeTypeId: 'customerHasProperty',
        //     labels: {
        //       in: 'The customer of this property',
        //       out: 'Property belonging to this customer',
        //     },
        //     edgeAttributes: {},
        //   },
        // },
        IrrigatorSequentialProgramme: {
            customerHasIrrigatorSequentialProgramme: {
                cardinality: undefined,
                edgeTypeId: 'customerHasIrrigatorSequentialProgramme',
                labels: {
                    in: 'customer has Sequential programme',
                    out: 'Sequential programme belongs to customer',
                },
                edgeAttributes: {},
            },
        },
        IrrigatorRollingProgramme: {
            customerHasIrrigatorRollingProgramme: {
                cardinality: undefined,
                edgeTypeId: 'customerHasIrrigatorRollingProgramme',
                labels: {
                    in: 'customer has rolling programme',
                    out: 'rolling programme belongs to customer',
                },
                edgeAttributes: {},
            },
        },
        Device: datamodel_core_1.edgeTypeMatrix.Customer.Device,
    },
    Waternetwork: {
        Entity: {
            waternetworkHasEntity: {
                cardinality: undefined,
                edgeTypeId: 'waternetworkHasEntity',
                labels: {
                    in: 'waternetwork has Entity',
                    out: 'Entity belongs to waternetwork',
                },
                edgeAttributes: {},
            },
        },
    },
    Property: {
        Paddock: {
            propertyHasPaddock: {
                cardinality: undefined,
                edgeTypeId: 'propertyHasPaddock',
                labels: {
                    in: 'Property with this paddock',
                    out: 'Paddock(s) in this property',
                },
                edgeAttributes: {},
            },
        },
        Waternetwork: {
            propertyHasWaternetwork: {
                cardinality: undefined,
                edgeTypeId: 'propertyHasWaternetwork',
                labels: {
                    in: 'property has Waternetwork',
                    out: 'Waternetwork belongs to property',
                },
                edgeAttributes: {},
            },
        },
        Waterway: {
            propertyHasWaterways: {
                cardinality: undefined,
                edgeTypeId: 'propertyHasWaterways',
                labels: {
                    in: 'Property with this waterway',
                    out: 'Waterway(s) in this property',
                },
                edgeAttributes: {},
            },
        },
        IrrigationZone: {
            propertyHasIrrigatationZone: {
                cardinality: undefined,
                edgeTypeId: 'propertyHasIrrigatationZone',
                labels: {
                    in: 'Property of this Irrigation Zone',
                    out: 'Irrigation zone(s) in this property',
                },
                edgeAttributes: {},
            },
        },
        IrrigationSequentialSchedule: {
            propertyHasIrrigationSequentialSchedule: {
                cardinality: undefined,
                edgeTypeId: 'propertyHasIrrigationSequentialSchedule',
                labels: {
                    in: 'Property with this squential programme',
                    out: 'Sequential programms made for this property',
                },
                edgeAttributes: {},
            },
        },
        IrrigationValveSchedule: {
            propertyHasIrrigationValveSchedule: {
                cardinality: undefined,
                edgeTypeId: 'propertyHasIrrigationValveSchedule',
                labels: {
                    in: 'Property with this squential programme',
                    out: 'Valve programms made for this property',
                },
                edgeAttributes: {},
            },
        },
        IrrigationRollingSchedule: {
            propertyHasIrrigationRollingSchedule: {
                cardinality: undefined,
                edgeTypeId: 'propertyHasIrrigationRollingSchedule',
                labels: {
                    in: 'Property with this Rolling programme',
                    out: 'Rolling programms made for this property',
                },
                edgeAttributes: {},
            },
        },
        Irrigator: {
            propertyHasIrrigator: {
                cardinality: undefined,
                edgeTypeId: 'propertyHasIrrigator',
                labels: {
                    in: 'Property has Irrigator',
                    out: 'Irrigator is for Property',
                },
                edgeAttributes: {},
            },
        },
        EffluentPath: {
            propertyHasEffluentPath: {
                cardinality: undefined,
                edgeTypeId: 'propertyHasEffluentPath',
                labels: {
                    in: 'Property with this effluent path',
                    out: 'Effluent path in this property',
                },
                edgeAttributes: {},
            },
        },
        // EntityRollingProgramme: {
        //   propertyHasEntityRollingProgramme: {
        //     cardinality: undefined,
        //     edgeTypeId: 'rolling_programme_schedules_group',
        //     labels: {
        //       in: 'Property with this Rolling programme',
        //       out: 'Rolling programms made for this property',
        //     },
        //     edgeAttributes: {},
        //   },
        // },
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'EntityRollingProgramme'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'Dam'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'EffluentPond'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'EffluentSump'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'EffluentTank'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'FlowMeter'),
        // ...getParentToChildEdgeTypeMatrixEntry('Property', 'Irrigator'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'EffluentSpreader'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'LateralEffluentSpreader'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'PivotEffluentSpreader'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'Pump'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'SoilMoisture'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'Tank'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'TravellingEffluentSpreader'),
        // ...getParentToChildEdgeTypeMatrixEntry('Property', 'EffluentTracker'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'SpreadingEvent'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'SpreadingGun'),
        // ...getParentToChildEdgeTypeMatrixEntry('Property', 'Paddock'),
        // ...getParentToChildEdgeTypeMatrixEntry('Property', 'Pond'),
        // ...getParentToChildEdgeTypeMatrixEntry('Property', 'Trough'),
        // ...getParentToChildEdgeTypeMatrixEntry('Property', 'WaterPump'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Property', 'SoilMoistureArea'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('Dam'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('EffluentPond'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('EffluentSump'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('EffluentTank'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('FlowMeter'),
        // // irrigator
        // ...getPropertyToEntityEdgeTypeMatrixEntry('LateralEffluentSpreader'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('PivotEffluentSpreader'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('Pump'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('SoilMoisture'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('Tank'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('TravellingEffluentSpreader'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('EffluentTracker'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('SpreadingEvent'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('SpreadingGun'),
        // ...getPropertyToEntityEdgeTypeMatrixEntry('SoilMoistureArea'),
    },
    Group: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'Dam'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'EffluentPond'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'EffluentSump'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'EffluentTank'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'FlowMeter'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'Irrigator'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'EffluentSpreader'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'LateralEffluentSpreader'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'PivotEffluentSpreader'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'Pump'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'SoilMoisture'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'Tank'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'TravellingEffluentSpreader'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'EffluentTracker'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'SpreadingEvent'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'SpreadingGun'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'Paddock'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'Pond'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'Trough'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'WaterPump'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'SoilMoistureArea'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'MasterValve'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'SVCx'),
    },
    Area: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Area', 'Irrigator'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Area', 'SoilMoisture'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Area', 'MasterValve'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Area', 'AssetTracker'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Group', 'SVCx'),
        //     ...getAreaToEntityMatrixEntry('Irrigator'),
        // ...getAreaToEntityMatrixEntry('SoilMoisture'),
    },
    EffluentTracker: {
        DeadZone: {
            EffluentTrackerHasDeadZone: {
                cardinality: undefined,
                edgeTypeId: 'effluentTracker_has_deadZone',
                labels: {
                    in: 'effluent tracker has dead zone',
                    out: 'dead zone due to effluent tracker',
                },
                edgeAttributes: {},
            },
        },
    },
    LateralEffluentSpreader: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('LateralEffluentSpreader', 'DeadZone'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('LateralEffluentSpreader', 'SpreadingGun'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('LateralEffluentSpreader', 'Pump'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('LateralEffluentSpreader', 'FlowMeter'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('LateralEffluentSpreader', 'Device'),
    },
    TravellingEffluentSpreader: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('TravellingEffluentSpreader', 'DeadZone'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('TravellingEffluentSpreader', 'Pump'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('TravellingEffluentSpreader', 'FlowMeter'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('TravellingEffluentSpreader', 'Device'),
    },
    PivotEffluentSpreader: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('PivotEffluentSpreader', 'DeadZone'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('PivotEffluentSpreader', 'SpreadingGun'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('PivotEffluentSpreader', 'Pump'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('PivotEffluentSpreader', 'FlowMeter'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('PivotEffluentSpreader', 'Device'),
    },
    SpreadingGun: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('SpreadingGun', 'Pump'),
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('SpreadingGun', 'FlowMeter'),
    },
    IrrigationPattern: {
        IrrigatorSchedule: {
            // Pump: {
            //   PivotEffluentSpreaderHasPumpController: {
            //     cardinality: undefined,
            //     edgeTypeId: 'PivotEffluentSpreaderHasPumpController',
            //     labels: {
            //       in: 'Pivot effluent spreader has pump controller',
            //       out: 'pump controller affects pivot effluent spreader',
            //     },
            //     edgeAttributes: {},
            //   },
            // },
            irrigatorPatternHasIrrigatorSchedule: {
                cardinality: undefined,
                edgeTypeId: 'irrigatorPatternHasIrrigatorSchedule',
                labels: {
                    in: 'irrigator pattern has irrigator schedule',
                    out: 'irrigator schedule belongs to irrigator pattern',
                },
                edgeAttributes: {},
            },
        },
        IrrigatorSequentialProgramme: {
            irrigatorPatternHasIrrigatorSequentialProgrammee: {
                cardinality: undefined,
                edgeTypeId: 'irrigatorPatternHasIrrigatorSequentialProgrammee',
                labels: {
                    in: 'irrigator pattern has irrigator sequential programme',
                    out: 'irrigator sequential programme belongs to irrigator pattern',
                },
                edgeAttributes: {},
            },
        },
        Irrigator: {
            IrrigationPatternAppliedToIrrigator: {
                cardinality: undefined,
                edgeTypeId: 'IrrigationPatternAppliedToIrrigator',
                labels: {
                    in: 'irrigator pattern applied to irrigator',
                    out: 'irrigator has irrigator pattern applied',
                },
                edgeAttributes: {},
            },
        },
    },
    IrrigationZone: {
        Irrigator: {
            IrrigationZoneHasIrrigator: {
                cardinality: undefined,
                edgeTypeId: 'IrrigationZoneHasIrrigator',
                labels: {
                    in: 'Irrigator(s) in this irrigator zone',
                    out: 'Irrigator belongs to this irrigator zone',
                },
                edgeAttributes: {},
            },
        },
        //TODO? well there isn't technically an edge between zones and programmes, but there is a psuedo-edge, this should be cleaned up.
        IrrigationPattern: {
            IrrigationZoneHasIrrigationPattern: {
                cardinality: undefined,
                edgeTypeId: 'IrrigationZoneHasIrrigationPattern',
                labels: {
                    in: 'irrigator zone has irrigation pattern',
                    out: 'irrigation pattern applies to irrigator zone',
                },
                edgeAttributes: {},
            },
        },
    },
    IrrigationSequentialSchedule: {
        IrrigatorSeqProgrammeHistory: {
            IrrigationSequentialScheduleHasIrrigatorSeqProgrammeHistory: {
                cardinality: undefined,
                edgeTypeId: 'IrrigationSequentialScheduleHasIrrigatorSeqProgrammeHistory',
                labels: {
                    in: 'irrigator sequential programme has history',
                    out: 'history applies to irrigator sequential programme',
                },
                edgeAttributes: {},
            },
        },
        IrrigationPattern: {
            IrrigationSequentialProgrammeHasIrrigationPattern: {
                cardinality: undefined,
                edgeTypeId: 'IrrigationSequentialProgrammeHasIrrigationPattern',
                labels: {
                    in: 'irrigator sequential programme has irrigation patttern',
                    out: 'irrigation patttern applies to irrigator sequential programme',
                },
                edgeAttributes: {},
            },
        },
        Irrigator: {
            IrrigationSequentialProgrammeAppliedToIrrigator: {
                cardinality: undefined,
                edgeTypeId: 'IrrigationSequentialProgrammeAppliedToIrrigator',
                labels: {
                    in: 'irrigator sequential programme applied to irrigator',
                    out: 'irrigator has irrigator sequential programme applied',
                },
                edgeAttributes: {},
            },
        },
        IrrigationZone: {
            IrrigationSequentialScheduleUsesIrrigationZone: {
                cardinality: undefined,
                edgeTypeId: 'IrrigationSequentialScheduleUsesIrrigationZone',
                labels: {
                    in: 'Irrigator sequential programme useing this irrigation zone',
                    out: 'Irrigation zones using this programme',
                },
                edgeAttributes: {},
            },
        },
    },
    IrrigationRollingSchedule: {
        IrrigatorRollingProgrammeHistory: {
            IrrigationRollingScheduleHasIrrigatorSeqProgrammeHistory: {
                cardinality: undefined,
                edgeTypeId: 'IrrigationRollingScheduleHasIrrigatorSeqProgrammeHistory',
                labels: {
                    in: 'irrigator Rolling programme has history',
                    out: 'history applies to irrigator Rolling programme',
                },
                edgeAttributes: {},
            },
        },
        IrrigationPattern: {
            IrrigationRollingProgrammeHasIrrigationPattern: {
                cardinality: undefined,
                edgeTypeId: 'IrrigationRollingProgrammeHasIrrigationPattern',
                labels: {
                    in: 'irrigator Rolling programme has irrigation patttern',
                    out: 'irrigation patttern applies to irrigator Rolling programme',
                },
                edgeAttributes: {},
            },
        },
        Irrigator: {
            IrrigationRollingProgrammeAppliedToIrrigator: {
                cardinality: undefined,
                edgeTypeId: 'IrrigationRollingProgrammeAppliedToIrrigator',
                labels: {
                    in: 'irrigator Rolling programme applied to irrigator',
                    out: 'irrigator has irrigator Rolling programme applied',
                },
                edgeAttributes: {},
            },
        },
        IrrigationZone: {
            IrrigationRollingScheduleUsesIrrigationZone: {
                cardinality: undefined,
                edgeTypeId: 'IrrigationRollingScheduleUsesIrrigationZone',
                labels: {
                    in: 'Irrigator Rolling programme useing this irrigation zone',
                    out: 'Irrigation zones using this programme',
                },
                edgeAttributes: {},
            },
        },
    },
    Irrigator: {
        Device: {
            IrrigatorHasDevice: {
                cardinality: undefined,
                edgeTypeId: 'IrrigatorHasDevice',
                labels: {
                    in: 'Irrigator linked to this device',
                    out: 'Device EUI attached to this irrigator',
                },
                edgeAttributes: {},
            },
        },
    },
    // Device: {
    //   IrrigationDeviceConfig: {
    //     IrrigatorDeviceHasIrrigationDeviceConfig: {
    //       cardinality: undefined,
    //       edgeTypeId: 'DeviceHasConfig',
    //       labels: {
    //         in: 'Device with this configuration',
    //         out: 'configuration of this device',
    //       },
    //       edgeAttributes: {},
    //     },
    //   },
    // },
    Paddock: {
        Irrigator: {
            PaddockHasIrrigator: {
                cardinality: undefined,
                edgeTypeId: 'PaddockHasIrrigator',
                labels: {
                    in: 'Irrigator is a part of this paddock',
                    out: 'Paddock has irrigator(s)',
                },
                edgeAttributes: {},
            },
        },
    },
    FlowMeter: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('FlowMeter', 'Device'),
    },
    Tank: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Tank', 'Device'),
    },
    Dam: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Dam', 'Device'),
    },
    AssetTracker: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('AssetTracker', 'Device'),
    },
    EffluentPond: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('EffluentPond', 'Device'),
    },
    EffluentSump: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('EffluentSump', 'Device'),
    },
    Pump: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('Pump', 'Device'),
    },
    SoilMoisture: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('SoilMoisture', 'Device'),
    },
    SVCx: {
        ...(0, datamodel_core_1.getParentToChildEdgeTypeMatrixEntry)('SoilMoisture', 'SVCx'),
    },
};
exports.typedEdgeTypeMatrix = exports.edgeTypeMatrix; // as EdgeTypeMatrixType
